import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';

import { Box, Flex, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import strikeThrough from './assets/strike-through.svg';
import { messages } from './messages';

/**
 * This depicts the left side modal as shown here:
 * https://www.figma.com/design/gN2uHK0wPD93kkqExPlNeM/Confluence%3A-Recommend-Standard-to-RT-trialing-customers-(RT)?node-id=3730-11924&node-type=frame&t=ZS7oExyVxcrlRkJQ-0
 */
export const PriceContrast = ({
	standardPrice,
	premiumPrice,
}: {
	standardPrice: number;
	premiumPrice: number;
}) => {
	const { formatMessage } = useIntl();
	const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
	const formattedStandardPrice = currencyFormatter.format(standardPrice);
	const formattedPremiumPrice = currencyFormatter.format(premiumPrice);

	return (
		<Flex xcss={outerFrameStyles} gap="space.300" alignItems="center" justifyContent="center">
			<Box xcss={strikeThroughStyles}>
				<img src={strikeThrough} alt="strike through" />
			</Box>
			<Flex direction="column">
				<Box xcss={premiumPriceStyles}>{formattedPremiumPrice}</Box>
				<Text size="small" color="color.text.accent.gray">
					{formatMessage(messages.perUserPerMonth)}
				</Text>
				<Text>Premium</Text>
			</Flex>
			<Stack>
				<Box xcss={standardPriceStyles}>
					<Purple>{formattedStandardPrice}</Purple>
				</Box>
				<Text size="small" color="color.text.accent.gray">
					{formatMessage(messages.perUserPerMonth)}
				</Text>
				<Text>Standard</Text>
			</Stack>
		</Flex>
	);
};

const outerFrameStyles = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
	paddingTop: 'space.200',
	paddingBottom: 'space.200',
	paddingLeft: 'space.100',
	paddingRight: 'space.300',
	height: '185px',
});

const standardPriceStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '48px',
	fontWeight: '700',
	lineHeight: '56px' /* 116.667% */,
});

const premiumPriceStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '48px',
	fontWeight: '700',
	lineHeight: '56px' /* 116.667% */,
	minWidth: '90px',
	position: 'relative',
	padding: 'space.0',
});

const strikeThroughStyles = xcss({
	top: '-27px',
	left: '35px',
	maxWidth: '0',
	maxHeight: '0',
	padding: 'space.0',
	zIndex: 'tooltip',
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Purple = styled.span({
	color: token('color.icon.accent.purple'),
});
